import React, { useState } from 'react';
import useStorage from '../../utils/useStorage';
import StoreContext from './context';

const initialCashierOpen = {
  open: false,
  cashierId: null,
};

const StoreProvider = ({ ...children }) => {
  const [credencials, setCredencials] = useStorage('userAcess');
  const [openModal, setOpenModal] = useState(false);
  const [modalUpgradePlan, setModalUpgradePlan] = useState(false);
  const [modalCashierSelect, setModalCashierSelect] = useState(false);
  const [modalCashierOpen, setModalCashierOpen] = useState(initialCashierOpen);
  const [searchState, setSearchState] = useState({});
  const [chatbotOpen, setChatbotOpen] = useState(false);
  const [chatbotSpecialist, setChatbotSpecialist] = useState(null);
  const [chatbotInitialPrompt, setChatbotInitialPrompt] = useState('');
  const [chatbotUnreadCount, setChatbotUnreadCount] = useState(0);

  const openChatbotWithPrompt = (prompt, specialist = null) => {
    setChatbotInitialPrompt(prompt || '');
    if (specialist) {
      setChatbotSpecialist(specialist);
    } else {
      setChatbotSpecialist(null);
    }
    setChatbotOpen(true);
    setChatbotUnreadCount(0);
  };

  return (
    <StoreContext.Provider
      value={{
        credencials,
        setCredencials,
        openModal,
        setOpenModal,
        modalUpgradePlan,
        setModalUpgradePlan,
        modalCashierSelect,
        setModalCashierSelect,
        modalCashierOpen,
        setModalCashierOpen,
        searchState,
        setSearchState,
        chatbotOpen,
        setChatbotOpen,
        chatbotSpecialist,
        setChatbotSpecialist,
        chatbotInitialPrompt,
        setChatbotInitialPrompt,
        openChatbotWithPrompt,
        chatbotUnreadCount,
        setChatbotUnreadCount,
      }}
    >
      {children.children}
    </StoreContext.Provider>
  );
};

export default StoreProvider;
